import { Header } from "metabase/visualizer/components/Header";
import { HeaderWrapper } from "./header-wrapper";
import { MinWrapper } from "./min-wrapper";
import ega_logo from "../assets/images/ega_pic.png";
import dat_log from "../assets/images/dat_pic.png"
import { headerItemData } from "./header-item-data";
import { HeaderItem } from "./header-item";
import { HeaderImageWrapper } from "./header-image-wrapper";
import { HeaderItemWrapper } from "./header-item-wrapper";


function LandingHeader() {
    return (
        <HeaderWrapper>
            <MinWrapper>
                <HeaderImageWrapper src={dat_log} alt="dat_logo" />
                <HeaderItemWrapper>
                    {
                        headerItemData.map((item, index) =>
                            <a href={item.link}>
                                <HeaderItem key={index}>
                                    {item.title}
                                </HeaderItem>
                            </a>
                        )
                    }
                </HeaderItemWrapper>
                <HeaderImageWrapper height={30} src={ega_logo} alt="ega_logo" />
            </MinWrapper>
        </HeaderWrapper>
    );
}
export default LandingHeader;